var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCartFilled = function SvgShoppingCartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20a2 2 0 1 1 0 4 2 2 0 0 1 0-4M17 20a2 2 0 1 1 0 4 2 2 0 0 1 0-4M1.222 0A3 3 0 0 1 4.2 2.65l.042.35H20.41a3 3 0 0 1 2.303 1.077 3 3 0 0 1 .65 2.456l-.785 4.354A5 5 0 0 1 17.658 15H5.737a3 3 0 0 0 2.819 2H19a1 1 0 0 1 0 2H8.557a5 5 0 0 1-4.966-4.417l-1.376-11.7A1 1 0 0 0 1.222 2H1a1 1 0 0 1 0-2z"
  })));
};
export default SvgShoppingCartFilled;